export default {
    DEPLOY_APPLY: 1001,
    DEPLOY_VIEW: 1002,
    DEPLOY_AUDIT: 1003,
    DEPLOY_DEPLOY: 1004,
    DEPLOY_DROP: 1005,
    DEPLOY_EDIT: 1006,

    PROJECT_SPACE_VIEW: 2001,
    PROJECT_SPACE_NEW: 2002,
    PROJECT_SPACE_EDIT: 2003,
    PROJECT_SPACE_DEL: 2004,
    PROJECT_USER_VIEW: 2100,
    PROJECT_USER_NEW: 2101,
    PROJECT_USER_DEL: 2102,
    PROJECT_VIEW: 2201,
    PROJECT_NEW: 2202,
    PROJECT_EDIT: 2203,
    PROJECT_DEL: 2204,
    PROJECT_AUDIT: 2205,
    PROJECT_BUILD: 2206,
    PROJECT_HOOK: 2207,

    USER_ROLE_VIEW: 3001,
    USER_ROLE_NEW: 3002,
    USER_ROLE_EDIT: 3003,
    USER_ROLE_DEL: 3004,
    USER_VIEW: 3101,
    USER_NEW: 3102,
    USER_EDIT: 3103,
    USER_DEL: 3104,

    SERVER_GROUP_VIEW: 4001,
    SERVER_GROUP_NEW: 4002,
    SERVER_GROUP_EDIT: 4003,
    SERVER_GROUP_DEL: 4004,
    SERVER_VIEW: 4101,
    SERVER_NEW: 4102,
    SERVER_EDIT: 4103,
    SERVER_DEL: 4104,

    COMMAND_TEMPLATE_VIEW: 5001,
    COMMAND_TEMPLATE_NEW: 5002,
    COMMAND_TEMPLATE_EDIT: 5003,
    COMMAND_TEMPLATE_DEL: 5004,
    COMMAND_TEMPLATE_SWITCHSTATUS: 5005,
    COMMAND_OPERATE_VIEW: 5101,
    COMMAND_OPERATE_NEW: 5102,
    COMMAND_OPERATE_EDIT: 5103,
    COMMAND_OPERATE_DEL: 5104,
    COMMAND_OPERATE_AUDIT: 5105,
    COMMAND_OPERATE_EXECUTE: 5106,
    COMMAND_OPERATE_DROP:5107,
    WORKFLOW_VIEW: 5201,
    WORKFLOW_NEW: 5202,
    WORKFLOW_EDIT: 5203,
    WORKFLOW_DEL: 5204,
    WORKFLOW_DROP: 5205,
    WORKFLOW_ONEKEY_AUDIT: 5206,
    WORKFLOW_FINISH: 5207,
}
